export default __webpack_public_path__ + "static/media/agreement.36218c6b.svg";